// 20261027 カートの通常の行（受注・予約の印がない、販売継続ONのサイズ）を今の在庫と比べ、
// 他のお客様の注文などで在庫が足りなくなった分をカートから外して「在庫切れのため削除しました」と出す
// 受注の案内はしない（入れ直しに行くと、そのサイズは受注の表示になっている）
(function () {
  const MESSAGE_KEY = 'preorderStockRemoved';
  const TRIED_KEY = 'preorderStockTried';
  const isJa = (document.documentElement.lang || 'ja').startsWith('ja');

  function showMessage(titles) {
    const box = document.createElement('div');
    box.className = 'preorder-stock-toast';
    box.setAttribute('role', 'alert');
    const text = isJa
      ? `在庫切れのため、${titles.join('、')} をカートから削除しました。`
      : `${titles.join(', ')} ${titles.length > 1 ? 'were' : 'was'} removed from your cart because it is out of stock.`;
    box.innerHTML = `<p></p><button type="button" aria-label="${isJa ? '閉じる' : 'Close'}">×</button>`;
    box.querySelector('p').textContent = text;
    box.querySelector('button').addEventListener('click', () => box.remove());
    document.body.appendChild(box);
  }

  function pending() {
    try {
      const saved = sessionStorage.getItem(MESSAGE_KEY);
      if (!saved) return;
      sessionStorage.removeItem(MESSAGE_KEY);
      showMessage(JSON.parse(saved));
    } catch (e) {}
  }

  function check() {
    // カートページとカートドロワーに同じ行があるので、行のキーで1つにまとめる
    const lines = {};
    document.querySelectorAll('[data-stock-line]').forEach((row) => {
      lines[row.dataset.stockLine] = {
        key: row.dataset.stockLine,
        variant: row.dataset.stockVariant,
        qty: Number(row.dataset.stockQty),
        available: Number(row.dataset.stockAvailable),
        title: row.dataset.stockTitle,
      };
    });

    const byVariant = {};
    Object.values(lines).forEach((line) => {
      (byVariant[line.variant] = byVariant[line.variant] || []).push(line);
    });

    const changes = [];
    const titles = [];
    Object.values(byVariant).forEach((group) => {
      const total = group.reduce((sum, line) => sum + line.qty, 0);
      let excess = total - Math.max(group[0].available, 0);
      if (excess <= 0) return;
      titles.push(group[0].title);
      // 後から入れた行から減らす
      group.reverse().forEach((line) => {
        if (excess <= 0) return;
        const cut = Math.min(line.qty, excess);
        excess -= cut;
        changes.push({ id: line.key, quantity: line.qty - cut });
      });
    });
    if (changes.length === 0) {
      try {
        sessionStorage.removeItem(TRIED_KEY);
      } catch (e) {}
      return;
    }

    // 外せなかったときに読み込み直しを繰り返さないよう、同じ内容は1回だけ試す
    const signature = JSON.stringify(changes);
    try {
      if (sessionStorage.getItem(TRIED_KEY) === signature) return;
      sessionStorage.setItem(TRIED_KEY, signature);
    } catch (e) {
      return;
    }

    const url = `${(window.routes && window.routes.cart_change_url) || '/cart/change'}.js`;
    changes
      .reduce(
        (chain, change) =>
          chain.then(() =>
            fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(change),
            })
          ),
        Promise.resolve()
      )
      .then(() => {
        try {
          sessionStorage.setItem(MESSAGE_KEY, JSON.stringify(titles));
        } catch (e) {}
        window.location.reload();
      })
      .catch(() => {});
  }

  pending();
  check();
})();
